<template>
  <div class="integral">
    <div class="desc">
      <div>积分中心</div>
      <div class="desc-right">
        <div class="residuePoints-title">剩余可用积分：</div>
        <div class="residuePoints">{{ residuePoints }}</div>
      </div>
    </div>
    <div class="table">
      <el-table class="table-container" :data="integralList">
        <el-table-column
          v-for="(item, index) in tableTitle"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        ></el-table-column>
          <el-table-column
            label="积分值"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type === 1 || scope.row.type === 3" style="display: inline-block; width: 10px;">+</span>
              <span v-else style="display: inline-block; width: 10px;text-align: center">-</span>
              <span>{{ scope.row.integralValue }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="remarks"
            label="备注"
          >
          </el-table-column>
      </el-table>
    </div>
    <div class="pagination-tpl-container">
      <pagination-tpl
        :total="totalNum"
        :currentPage="currentPage"
        @queryChange="onQueryChange"
      ></pagination-tpl>
    </div>
  </div>
</template>

<script>
import XBPoints from "models/xb/points.js";
import PaginationTpl from "base/PaginationTpl";
import { formaTimeToSecond } from 'common/js/util.js';
const TYPE = {1:'获取', 2:'使用', 3: '充值', 4:'扣款', 5:'过期'}
export default {
  components: {
    PaginationTpl,
  },

  data() {
    return {
      // 当前页面
      currentPage: 1,
      // 订单总条数
      totalNum: 0,
      integralList: [],
      residuePoints: 0,
      tableTitle: [
        { label: '时间', prop: 'creatTime' },
        { label: '类型', prop: 'typeVal' },
        // { label: '积分值', prop: 'integralValue' },
        // { label: '备注', prop: 'remarks' },
      ]
    };
  },

  created() {
    this.initIntegralList()
  },

  methods: {
    /* 翻页 */
    onQueryChange(query) {
      this.currentPage = query.currentPage;
      this.initIntegralList();
    },
    initIntegralList() {
      let currentPage = this.currentPage
      XBPoints.postXBPointsContentList(currentPage).then(res => {
        if (res.success) {
          this.residuePoints = res.result.availablePoints
          this.totalNum = res.result.pageBean.totalNum
          let arr = []
          res.result.pageBean.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.creatTime = formaTimeToSecond(i.eventTime)
            obj.type = i.type
            obj.typeVal = TYPE[i.type]
            obj.integralValue = i.value
            obj.remarks = i.desc
            arr.push(obj)
          })
          this.integralList = arr
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      })
    }
  },
};
</script>

<style lang='scss'>
.integral {
  padding: 0 20px;
  .desc {
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: rgba(96, 98, 102, 1);
    border-bottom: 1px solid #e4e4e4;
    margin-bottom: 20px;
    font-size: 16px;
    .desc-right {
      display: flex;
      .residuePoints-title {
        color: #999;
        font-size: 16px;
      }
      .residuePoints {
        color: red;
      }
    }
  }
  .table {
    .el-table {
      font-family: "PingFangSC-Regular";
      border: 1px solid #eee;
      border-bottom: 0;
      border-radius: 8px 8px 0px 0px;
      .el-table__header-wrapper {
        background: #F9F9F9;
        .el-table__header {
          tr {
            th {
              background: #F9F9F9;
              padding: 0;
              height: 34px;
              .cell {
                color: #606266;
                line-height: 16px;
                padding: 8px 16px;
                font-size: 14px;
              }
            }
          }
        }
      }
      .el-table__body-wrapper {
        .el-table__body {
          tr {
            height: 34px;
            padding: 0;
            td {
              height: 34px;
              padding: 0;
              .cell {
                color: #606266;
                font-size: 14px;
                padding: 0 0 0 16px;
                height: 34px;
                line-height: 34px;
              }
            }
          }
        }
      }
    }
  }
  .pagination-tpl-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>
